"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollX;

var _isWindow = _interopRequireDefault(require("./isWindow"));

var _isElement = _interopRequireDefault(require("./isElement"));

function scrollX(elOrWindow) {
  if (elOrWindow === void 0) {
    elOrWindow = window;
  }

  var x = 0;

  if ((0, _isWindow["default"])(elOrWindow)) {
    var win = elOrWindow;
    x = win.scrollX || win.pageXOffset || win.document.documentElement.scrollLeft;
  } else if ((0, _isElement["default"])(elOrWindow)) {
    x = elOrWindow.scrollLeft;
  }

  return x;
}

module.exports = exports.default;